import MiddlePanel from 'Components/MiddlePanel/MiddlePanel';
import Panel from 'Components/Panel/Panel';
import { useEffect, useState } from 'react';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';

const EmployeeAllocated = ({
    onUpdateShowEmployeeAllocatedPanel,
    showEmployeeAllocatedPanel,
    productionDaysIdSelected,
    productionDayDateToDuplicate
}) => {
    const [productionEmployeesList, setEmployeeAllocatedList] = useState(null)
    const [loadingEmployeeAllocatedPanel, setLoadingEmployeeAllocatedPanel] = useState(null);

    const [employeeDayId, setEmployeeDayId] = useState(null)
    const [employeeId, setEmployeeId] = useState(null)

    useEffect(() => {
        if (productionDaysIdSelected) {
            getEmployeeRecords(productionDaysIdSelected, productionDayDateToDuplicate)
        }
    }, [productionDayDateToDuplicate, productionDaysIdSelected, showEmployeeAllocatedPanel])


    async function getEmployeeRecords(productionDaysIdSelected, productionDayDateToDuplicate) {
        try {
            setLoadingEmployeeAllocatedPanel(true)
            const parameters = { productionDayId: productionDaysIdSelected, productionDayDate: productionDayDateToDuplicate }
            const productionEmployeesList = await ExecuteAxios.api('get', `/production-day/get-allocated-employees-grid/`, { params: parameters });
            setEmployeeAllocatedList(productionEmployeesList);
        } finally {
            setLoadingEmployeeAllocatedPanel(false)
        }
    }

    const styleButtonsMonth = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%'
    }

    function closePanel(onUpdateShowEmployeeAllocatedPanel) {
        onUpdateShowEmployeeAllocatedPanel(false)
    }

    return (
        <MiddlePanel isVisible={showEmployeeAllocatedPanel}>
            <Panel style={{
                minWidth: 'min(400px, calc(100vw - 24px))',
                minHeight: '300px',
                borderRadius: '10px',
                backgroundColor: '#f5f5f5;',
                display: 'flex',
                border: '1px solid #ccc',
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 30%)'
            }}>
                <Panel titlePage={'Colaboradores alocados:'}
                    canViewCRUD={true}
                    style={styleButtonsMonth}
                    cancelFunction={() => { closePanel(onUpdateShowEmployeeAllocatedPanel) }}
                    cancelNameButton='Fechar'
                    updating={true}
                    recordsSelected={[]}>
                    <LoadingIndicator loaded={!loadingEmployeeAllocatedPanel} stylePanel={{ height: '246px' }}>
                        <PanelListDefault
                            onUpdateIdSelected={null}
                            idsSelected={[]}
                            data={productionEmployeesList}
                        />
                    </LoadingIndicator>
                </Panel>
            </Panel>
        </MiddlePanel >
    );
}

export default EmployeeAllocated;
